import React from "react";

export default function MySQL_SPACE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_SPACE</h1>
      <p>This is the MySQL_SPACE component generated from the SQL JSON.</p>
    </div>
  );
}
